const MENU_SELECTOR = '[data-spot-dropdown]';

function closeMenu(menu) {
  if (menu?.open) menu.removeAttribute('open');
}

function initSpotAccountMenu() {
  const menus = Array.from(document.querySelectorAll(MENU_SELECTOR));
  if (!menus.length) return;

  menus.forEach((menu) => {
    if (menu.dataset.spotAccountReady === 'true') return;
    menu.dataset.spotAccountReady = 'true';

    const trigger = menu.querySelector('summary');
    if (!(trigger instanceof HTMLElement)) return;

    menu.addEventListener('toggle', () => {
      if (!menu.open) return;
      document.querySelectorAll(MENU_SELECTOR).forEach((otherMenu) => {
        if (otherMenu !== menu) closeMenu(otherMenu);
      });

      const searchInput = menu.querySelector('.spot-search-menu__input');
      if (searchInput instanceof HTMLInputElement) {
        requestAnimationFrame(() => {
          searchInput.focus();
          searchInput.select();
        });
      }
    });
  });

  if (document.documentElement.dataset.spotAccountGlobalBound === 'true') return;
  document.documentElement.dataset.spotAccountGlobalBound = 'true';

  document.addEventListener('click', (event) => {
    const allMenus = document.querySelectorAll(MENU_SELECTOR);
    const target = event.target;
    if (!(target instanceof Node)) return;

    const closeTrigger = target instanceof Element ? target.closest('[data-spot-close-menu]') : null;
    if (closeTrigger instanceof Element) {
      const parentMenu = closeTrigger.closest(MENU_SELECTOR);
      closeMenu(parentMenu);
      return;
    }

    allMenus.forEach((menu) => {
      if (!menu.contains(target)) closeMenu(menu);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll(MENU_SELECTOR).forEach((menu) => closeMenu(menu));
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initSpotAccountMenu();
  });
} else {
  initSpotAccountMenu();
}

document.addEventListener('shopify:section:load', initSpotAccountMenu);
